import React from 'react';
import { BookOpen, Gamepad2, CalendarDays, Gift } from 'lucide-react';
export function BonusSection() {
  return <section className="bg-gray-50 py-10 md:py-14 px-4" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-8 font-['Oswald'] uppercase text-center" data-id="element-12">
          📦 ¿Qué incluye?
        </h2>

        {/* Main Guide */}
        <div className="bg-white rounded-xl shadow-lg p-6 border-2 border-blue-400 mb-6 text-center" data-id="element-13">
          <div className="inline-block bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-3" data-id="element-14">
            📘 GUÍA PRINCIPAL
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2 font-['Oswald']" data-id="element-15">
            El Asombroso Viaje por el Cuerpo Humano
          </h3>
          <p className="text-gray-600 text-sm" data-id="element-16">
            Un recorrido completo y visual por el cuerpo humano.
          </p>
        </div>

        {/* Bonuses */}
        <div className="text-center mb-4" data-id="element-17">
          <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded text-sm" data-id="element-18">
            🎁 BONOS GRATIS · Solo por tiempo limitado
          </div>
        </div>

        <div className="space-y-3" data-id="element-19">
          {[{
          icon: '📝',
          title: 'BONO 1 – Kit Premium de Evaluaciones',
          desc: 'Actividades listas para reforzar el aprendizaje.',
          image: 'https://cdn.magicpatterns.com/uploads/aSCyHz4WsMQZBfDwCeS1b3/bono1_sin_fondo.png'
        }, {
          icon: '🎲',
          title: 'BONO 2 – MegaPack de Juegos Didácticos',
          desc: 'Bingo, trivias y dinámicas para aprender jugando.',
          image: 'https://cdn.magicpatterns.com/uploads/gXd34HjrCJ5QfopDrvLCzH/bono2_sin_fondo.png'
        }, {
          icon: '📅',
          title: 'BONO 3 – Planificador Estratégico de Ciencias',
          desc: 'Organiza el aprendizaje de forma simple.',
          image: 'https://cdn.magicpatterns.com/uploads/8nevuoysUqhsGMPRifE3WW/bono3_sin_fondo.png'
        }].map((bonus, idx) => <div key={idx} className="bg-white rounded-xl shadow-md p-4 flex items-center gap-4 border border-gray-200" data-id="element-20">
              <img src={bonus.image} alt={bonus.title} className="w-20 h-20 object-contain flex-shrink-0" data-id="element-21" />
              <div data-id="element-22">
                <div className="inline-block bg-green-100 text-green-700 text-[10px] font-bold px-2 py-0.5 rounded mb-1" data-id="element-23">
                  GRATIS
                </div>
                <h4 className="text-sm font-bold text-gray-900" data-id="element-24">
                  {bonus.icon} {bonus.title}
                </h4>
                <p className="text-xs text-gray-600" data-id="element-25">{bonus.desc}</p>
              </div>
            </div>)}
        </div>

        {/* Everything in one place */}
        <div className="mt-8 bg-yellow-50 border-2 border-yellow-300 rounded-xl p-5 text-center" data-id="element-26">
          <p className="text-lg font-black text-gray-900 mb-1" data-id="element-27">
            💥 TODO EN UN SOLO LUGAR
          </p>
          <p className="text-sm text-gray-600" data-id="element-28">
            No necesitas buscar más materiales. No necesitas complicarte.
          </p>
          <p className="text-base font-bold text-gray-800 mt-2" data-id="element-29">
            👉 Aquí tienes todo listo para usar.
          </p>
        </div>
      </div>
    </section>;
}